import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const interests = [
    "General enquiry",
    "Medical Courier Vans",
    "Courier Vehicles",
    "RV Fleet",
    "Pilot Cars for Oversized Loads",
    "Partnership / Investment",
];

const empty = { name: "", email: "", company: "", interest: "General enquiry", message: "" };

export default function Enquiry() {
    const [form, setForm] = useState(empty);
    const [sending, setSending] = useState(false);

    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setSending(true);
        try {
            await axios.post(`${API}/enquiries`, form);
            toast.success("Enquiry sent — we'll get back to you within one business day.");
            setForm(empty);
        } catch {
            toast.error("Something went wrong sending your enquiry. Please try again.");
        } finally {
            setSending(false);
        }
    };

    return (
        <section id="enquiry" data-testid="enquiry-section" className="py-24 px-6">
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-start">
                <div>
                    <p className="font-mono2 text-xs uppercase tracking-widest text-amber-500 mb-4">
                        Contact
                    </p>
                    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-6">
                        Start the conversation
                    </h2>
                    <p
                        data-testid="enquiry-form-subtitle"
                        className="text-base text-slate-300 leading-relaxed max-w-md"
                    >
                        send an enquiry and we&rsquo;ll get back to you within one business day
                    </p>
                </div>
                <form
                    onSubmit={submit}
                    data-testid="enquiry-form"
                    className="border border-white/10 bg-white/[0.03] rounded-lg p-8 space-y-5"
                >
                    <div className="grid sm:grid-cols-2 gap-5">
                        <input
                            className="field"
                            placeholder="Name"
                            required
                            value={form.name}
                            onChange={set("name")}
                            data-testid="enquiry-name-input"
                        />
                        <input
                            className="field"
                            type="email"
                            placeholder="Email"
                            required
                            value={form.email}
                            onChange={set("email")}
                            data-testid="enquiry-email-input"
                        />
                    </div>
                    <input
                        className="field"
                        placeholder="Company (optional)"
                        value={form.company}
                        onChange={set("company")}
                        data-testid="enquiry-company-input"
                    />
                    <select
                        className="field"
                        value={form.interest}
                        onChange={set("interest")}
                        data-testid="enquiry-interest-select"
                    >
                        {interests.map((i) => (
                            <option key={i}>{i}</option>
                        ))}
                    </select>
                    <textarea
                        className="field min-h-[120px] resize-y"
                        placeholder="Message"
                        required
                        value={form.message}
                        onChange={set("message")}
                        data-testid="enquiry-message-input"
                    />
                    <button
                        type="submit"
                        disabled={sending}
                        data-testid="enquiry-submit-button"
                        className="inline-flex items-center gap-2 bg-amber-500 text-black font-semibold px-7 py-3 rounded-full hover:bg-amber-400 transition-colors duration-200 disabled:opacity-60"
                    >
                        {sending ? "Sending…" : "Send Enquiry"} <ArrowRight size={16} />
                    </button>
                </form>
            </div>
        </section>
    );
}
